// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../doc-site/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../doc-site/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bolt-editable-dropdown-with-selection .bolt-textfield-input::placeholder {
  color: rgba(0, 0, 0, .9);
  color: var(--text-primary-color,rgba(0, 0, 0, .9));
}
.bolt-editable-dropdown-with-selection .bolt-textfield-input::-webkit-input-placeholder {
  color: rgba(0, 0, 0, .9);
  color: var(--text-primary-color,rgba(0, 0, 0, .9));
}
.bolt-editable-dropdown-with-selection .bolt-textfield-input::-moz-placeholder {
  color: rgba(0, 0, 0, .9);
  color: var(--text-primary-color,rgba(0, 0, 0, .9));
  opacity: 1;
}
.bolt-editable-dropdown-with-selection .bolt-textfield-input::-ms-input-placeholder {
  color: rgba(0, 0, 0, .9);
  color: var(--text-primary-color,rgba(0, 0, 0, .9));
}

.bolt-editable-dropdown-focused-item {
  border: none !important;
  animation: focus-shadow-pulse-inset 4s ease-in-out infinite;
}
@media (forced-colors: active) {
  .bolt-editable-dropdown-focused-item {
    animation: none;
  }
}
.bolt-editable-dropdown-focused-item {
  box-shadow: inset 0 0 0 3px rgba(0, 120, 212, 0.23), inset 0 0 0 1px rgba(0, 120, 212, 1);
  box-shadow: inset 0 0 0 3px var(--focus-pulse-max-color,rgba(0, 120, 212, 0.23)), inset 0 0 0 1px var(--focus-border-color,rgba(0, 120, 212, 1));
  border-color: rgba(0, 120, 212, 1) !important;
  border-color: var(--communication-background,rgba(0, 120, 212, 1)) !important;
}
@media (forced-colors: active) {
  .bolt-editable-dropdown-focused-item {
    border-color: Highlight;
  }
}

.bolt-list-row.selected .bolt-editable-dropdown-focused-item {
  animation: focus-shadow-pulse-inset 4s ease-in-out infinite;
}
@media (forced-colors: active) {
  .bolt-list-row.selected .bolt-editable-dropdown-focused-item {
    animation: none;
  }
}
.bolt-list-row.selected .bolt-editable-dropdown-focused-item {
  box-shadow: inset 0 0 0 3px rgba(0, 120, 212, 0.23), inset 0 0 0 1px rgba(0, 120, 212, 1);
  box-shadow: inset 0 0 0 3px var(--focus-pulse-max-color,rgba(0, 120, 212, 0.23)), inset 0 0 0 1px var(--focus-border-color,rgba(0, 120, 212, 1));
  border-color: rgba(0, 120, 212, 1) !important;
  border-color: var(--communication-background,rgba(0, 120, 212, 1)) !important;
}
@media (forced-colors: active) {
  .bolt-list-row.selected .bolt-editable-dropdown-focused-item {
    background: Highlight;
  }
}

.bolt-dropdown-expandable-text-field.bolt-editable-dropdown:not(.disabled) .bolt-dropdown-expandable-textfield-input {
  cursor: text;
}

/*# sourceMappingURL=EditableDropdown.css.map */
`, "",{"version":3,"sources":["webpack://./../azure-devops-ui/src/Components/EditableDropdown/EditableDropdown.scss","webpack://./../azure-devops-ui/src/Core/_platformCommon.scss","webpack://./../azure-devops-ui/bin/Components/EditableDropdown/EditableDropdown.css","webpack://./../azure-devops-ui/src/_coreStyles.scss"],"names":[],"mappings":"AAEI;EACI,wBC0JO;EC3Jb,kDAAkD;AFIhD;AEFJ;EACE,wBAAwB;EFKtB,kDAAA;AEHJ;AACA;EACE,wBAAwB;EFMtB,kDAAA;EACI,UC6IO;ACjJf;AACA;EFOA,wBAAA;EACI,kDAAA;AELJ;;AC+BI;EH3BJ,uBAAA;EEAE,2DC0CM;ADzCR;AACA;EFFA;IG8CQ,eAAA;EH3CJ;AEGJ;ACqBI;EH3BJ,yFAAA;EESE,gJFHM;EEIN,6CAA6C;EAC7C,6EAA6E;AAC/E;AFFA;EGwBQ;IDnBJ,uBAAuB;ECYvB;ADVJ;;AAEA;EACE,2DAA2D;AFV7D;AEYA;EFVI;IEYA,eAAe;ECGf;ADDJ;AACA;EACE,yFAAyF;EACzF,gJAAgJ;EAChJ,6CAA6C;EFX/C,6EAAA;AEaA;AACA;EACE;IACE,qBAAqB;EACvB;AACF;;AAEA;EACE,YAAY;AACd;;AAEA,+CAA+C","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
